import { PropsWithChildren } from 'react';
import classNames from 'classnames';
import style from './Box.module.scss';

type Props = {
  className?: string;
};

function Box({ children, className }: PropsWithChildren<Props>) {
  return <div className={classNames(style.box, className)}>{children}</div>;
}

Box.defaultProps = {
  className: undefined,
};

export default Box;
